var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { handleErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { showDirectoryTreeDialog } from '../../features/file-manager';
export function showCopyDialog(params) {
    showDirectoryTreeDialog({
        showRootDirectory: params.showRootDirectory,
        title: params.t('copyDialog.title'),
        onChange: (directory) => __awaiter(this, void 0, void 0, function* () {
            try {
                yield params.copyFile({ fileId: params.file.id, selectedDirectoryId: directory === null || directory === void 0 ? void 0 : directory.id });
                showAlertSnackbar({
                    horizontalPosition: 'center',
                    type: 'success',
                    verticalPosition: 'bottom',
                    autoHideDuration: 2000,
                    message: params.t('copyDialog.copiedSnackbar'),
                });
                params.onSuccess();
            }
            catch (error) {
                handleErrorDialog(error);
            }
        }),
    });
}
